export default __webpack_public_path__ + "static/media/img-0018.ba450f23.png";